module.exports = __webpack_public_path__ + "download_windows_badge.b78ad02.png";